import React, { useEffect, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import googleAds from "../assets/img/googleAds.png";
import facebookCertificate from "../assets/img/facebookCertificate.png";
import hubspot from "../assets/img/HubSpot.jpg";
import accaCertified from "../assets/img/acca_accredited.png";
import questionMark from "../assets/img/question-mark.png";
import solution360 from "../assets/img/360-feedback.gif";
import customerHeart from "../assets/img/loyalty.gif";
// import anime from "animejs";

gsap.registerPlugin(ScrollTrigger);

const Banner = () => {
  useEffect(() => {
    const tl = gsap.timeline();
    tl.to(".hero_txt", {
      y: 0,
      stagger: {
        amount: 0.8,
      },
    });
    tl.to(".hero_txt11", {
      y: 0,
      stagger: {
        amount: 0.8,
      },
    });

    // Fullpage Scroll
    const tlt3 = gsap.timeline({
      scrollTrigger: {
        trigger: ".second_hero_sec",
        start: "top 70%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    const tlt4 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentText",
        start: "top 70%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    const tlt5 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextOne",
        start: "top 70%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    const tlt6 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextTwo",
        start: "top 70%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    const tlt12 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextFiveextra",
        start: "top 70%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    const tlt7 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextThree",
        start: "top 70%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    const tlt8 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextFour",
        start: "top 70%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    const tlt9 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextFive",
        start: "top 70%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    const tlt10 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextSix",
        start: "top 70%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    const tlt11 = gsap.timeline({
      scrollTrigger: {
        trigger: ".contentTextSeven",
        start: "top 70%",
        end: "17% 10%",
        scrub: 1,
        // markers: true,
      },
    });

    tlt3.to(".second_hero_sec", {
      opacity: 1,
      y: "-20rem",
    });

    tlt4.to(".contentText", {
      opacity: 1,
      y: "-20rem",
    });

    tlt5.to(".contentTextOne", {
      opacity: 1,
      y: "-20rem",
    });

    tlt6.to(".contentTextTwo", {
      opacity: 1,
      y: "-20rem",
    });

    tlt7.to(".contentTextThree", {
      opacity: 1,
      y: "-20rem",
    });

    tlt8.to(".contentTextFour", {
      opacity: 1,
      y: "-20rem",
    });

    tlt9.to(".contentTextFive", {
      opacity: 1,
      y: "-20rem",
    });

    tlt10.to(".contentTextSix", {
      opacity: 1,
      y: "-20rem",
    });

    tlt11.to(".contentTextSeven", {
      opacity: 1,
      y: "-20rem",
    });
    tlt12.to(".contentTextFiveextra", {
      opacity: 1,
      y: "-20rem",
    });
  }, []);

  const [textToShow, setTextToShow] = useState(0);

  // Array of texts to display
  const texts = ["Elevate Sales", "Lasting Impression", "Boost Visibility"];

  // Function to cycle through texts
  const cycleText = () => {
    setTextToShow((prev) => (prev + 1) % texts.length);
  };

  // Automatically cycle through texts every 2 seconds
  useEffect(() => {
    const interval = setInterval(cycleText, 3000);
    return () => clearInterval(interval);
  }, []);

  const [text, setText] = useState("");
  const [showCursor, setShowCursor] = useState(true);

  const textToType = "One strategy at a time";
  const typingSpeed = 100; // Speed in milliseconds

  useEffect(() => {
    let currentIndex = 0;
    let interval;

    const startTyping = () => {
      interval = setInterval(() => {
        if (currentIndex <= textToType.length) {
          setText(textToType.substring(0, currentIndex));
          currentIndex++;
        } else {
          clearInterval(interval);
          setTimeout(() => {
            setText("");
            currentIndex = 0;
            startTyping(); // Restart typing animation
          }, 1000); // Delay before restarting typing animation
        }
      }, typingSpeed);
    };

    startTyping(); // Start typing animation

    return () => clearInterval(interval);
  }, []); // Empty dependency array ensures this effect runs only once, on mount

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor((prev) => !prev);
    }, 500); // Blinking speed in milliseconds

    return () => clearInterval(cursorInterval);
  }, []);

  const phoneNumber = "447577842671"; // Replace with the desired phone number

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, "_blank");
  };
  return (
    <>
      {/* Banner Component Start Here */}
      <main className="heroMain">
        <section className="hero_sec fullpageScroll mb-5">
          {/* <div className="container">
            <h1 className="banner_txt">
              <div className={`text ${textToShow === 0 ? "active" : ""}`}>
                Elevate sales
              </div>
              <div className={`text ${textToShow === 1 ? "active" : ""}`}>
                Make a lasting impression
              </div>
              <div className={`text ${textToShow === 2 ? "active" : ""}`}>
                Boost visibility
              </div>
              <span className="hero_txt">w</span>
              <span className="hero_txt">i</span>
              <span className="hero_txt">t</span>
              <span className="hero_txt">h</span>
              <span className="hero_txt hero_txt11">C</span>
              <span className="hero_txt hero_txt11">r</span>
              <span className="hero_txt hero_txt11">i</span>
              <span className="hero_txt hero_txt11">s</span>
              <span className="hero_txt hero_txt11">p</span>
              <span className="hero_txt">B</span>
              <span className="hero_txt">r</span>
              <span className="hero_txt">a</span>
              <span className="hero_txt">i</span>
              <span className="hero_txt">n</span>
              <span className="hero_txt">s</span>
            </h1>
          </div> */}

          <div className="container">
            <h1 className="banner_txt">
              {texts.map((text, index) => (
                <div
                  key={index}
                  className={`text  ${textToShow === index ? "active" : ""}`}
                >
                  {text}
                </div>
              ))}{" "}
              <br />
              <div className="mt-2"></div>
              <span className="hero_txt">w</span>
              <span className="hero_txt">i</span>
              <span className="hero_txt">t</span>
              <span className="hero_txt">h</span>{" "}
              <span className="hero_txt hero_txt11">C</span>
              <span className="hero_txt hero_txt11">r</span>
              <span className="hero_txt hero_txt11">i</span>
              <span className="hero_txt hero_txt11">s</span>
              <span className="hero_txt hero_txt11">p</span>
              <span className="hero_txt">B</span>
              <span className="hero_txt">r</span>
              <span className="hero_txt">a</span>
              <span className="hero_txt">i</span>
              <span className="hero_txt">n</span>
              <span className="hero_txt">s</span>
            </h1>
          </div>
        </section>

        {/* <section
          className="second_hero_sec fullpageScroll"
          style={{ height: "80vh", opacity: 0 }}
        >
          <div className="container">
            <h2 className="subtitle" id="test">
              We're Not Just Another{" "}
              <span className="bg-text-color">Pretty Website</span>
            </h2>
          </div>
        </section> */}

        {/* <section
          className="contentText fullpageScroll"
          style={{ height: "80vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              <span className="bg-text-color"> Picture this: </span>
              <br /> you're setting up business in the bustling marketplace of
              the internet. It's exciting, but maybe a little overwhelming too.
              Enter <span className="hero_txt">CrispBrains</span>
              <span className="hero_txt">
                {" "}
                your friendly neighbor and marketing guru!{" "}
              </span>
            </h2>
          </div>
        </section> */}

        <section
          className="contentText for_css_text fullpageScroll"
          style={{ height: "80vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              <span className="bg-text-colors">
                {" "}
                Bridging Big Ideas with Small and Medium-Sized Businesses. Our
                passion is propelling SMEs to digital success, <br />
              </span>
            </h2>
            <h2 className="animated-text">
              <span>{text}</span>
              {showCursor && <span>|</span>}
            </h2>
          </div>
        </section>
        <section
          className="contentTextOne for_css_text fullpageScroll"
          style={{ height: "20vh", opacity: 0 }}
        >
          <div className="image360">
            <img src={questionMark} alt="" />
          </div>
        </section>
        <section
          className="contentTextOne for_css_text fullpageScroll extrabottomspace1"
          style={{ height: "50vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              Why Choose <span className="hero_txt">CrispBrains</span>: <br />{" "}
              {/* Fueling Your Growth with Digital Expertise */}
            </h2>
          </div>
        </section>

        {/* <section
          className="contentTextTwo for_css_text fullpageScroll"
          style={{ height: "80vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              In the digital jungle, choosing the right partner to guide your
              growth can feel daunting. But look no further than{" "}
              <span className="hero_txt">CrispBrains</span>, your oasis of
              proven expertise, innovative strategies, and relentless dedication
              to your success. Here's why we're the perfect catalyst for your
              digital transformation:
            </h2>
          </div>
        </section> */}

        <section
          className="contentTextThree for_css_text fullpageScroll"
          style={{ height: "80vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              <b>
                {" "}
                <span className="bg-text-color">1. Certified Excellence:</span>
              </b>{" "}
              <div className="imagesSection">
                <ul>
                  <li>
                    <img src={googleAds} alt="" />
                  </li>
                  <li>
                    <img src={hubspot} alt="" />
                  </li>

                  {/* <li>
                    <img src={hubspot} alt="" />
                  </li>
                  <li>
                    <img src={accaCertified} alt="" />
                  </li> */}
                </ul>
              </div>
              <div className="imagesSection extraspace">
                <ul>
                  {/* <li>
                    <img src={googleAds} alt="" />
                  </li>
                  <li>
                    <img src={facebookCertificate} alt="" />
                  </li> */}
                  <li>
                    <img src={facebookCertificate} alt="" />
                  </li>

                  <li>
                    <img src={accaCertified} alt="" />
                  </li>
                </ul>
              </div>
            </h2>
          </div>
        </section>

        <section
          className="contentTextFiveextra for_css_text fullpageScroll"
          style={{ height: "180vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              Our team isn't just passionate, it's powerhouse of accredited
              professionals holding certifications in Google Ads, Facebook
              Blueprint, HubSpot, and ACCA. This means we wield the latest tools
              and strategies with mastery, crafting campaigns that deliver real
              results, not just empty promises.
            </h2>
          </div>
        </section>
        {/* 
        <section
          className="contentTextFour for_css_text fullpageScroll"
          style={{ height: "80vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              <b>
                <span className="bg-text-color">
                  {" "}
                  2. Data-Driven Decisions:{" "}
                </span>
              </b>{" "}
              <br /> We're not fans of guesswork. Every decision we make is
              fueled by deep data analysis and tailored to your unique goals. We
              track, measure, and optimize continuously, ensuring your campaigns
              evolve alongside your business.
            </h2>
          </div>
        </section> */}
        <section
          className="contentTextOne for_css_text fullpageScroll"
          style={{ height: "10vh", opacity: 0 }}
        >
          <div className="image360">
            <img src={solution360} alt="" />
          </div>
        </section>

        <section
          className="contentTextFive for_css_text fullpageScroll"
          style={{ height: "180vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              <b>
                <span className="bg-text-color">2. 360° Solutions: </span>
              </b>{" "}
              <br /> We believe in a holistic approach. From captivating website
              design to engaging social media campaigns and laser-focused paid
              advertising, we cover all the bases, creating a seamless, powerful
              online presence that resonates with your audience.
            </h2>
          </div>
        </section>

        <section
          className="contentTextOne for_css_text fullpageScroll"
          style={{ height: "10vh", opacity: 0 }}
        >
          <div className="image360">
            <img src={customerHeart} alt="" />
          </div>
        </section>

        <section
          className="contentTextSix for_css_text fullpageScroll"
          style={{ height: "80vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              <b>
                <span className="bg-text-color">
                  3. Customer-Centric Heart:{" "}
                </span>
              </b>{" "}
              <br /> You're not just a number at CrispBrains. We take the time
              to understand your brand, your vision, and your challenges. We're
              your trusted partner, collaborating with you every step of the way
              to ensure your success is our shared victory.
            </h2>
          </div>
        </section>

        <section
          className="contentTextSeven for_css_text fullpageScroll"
          style={{ height: "50vh", opacity: 0 }}
        >
          <div className="container">
            <span className="make-me-flash">
              <h2 className="change-text">Still feeling uncertain?</h2>
            </span>
          </div>
        </section>

        <section
          className="contentTextSeven for_css_text fullpageScroll"
          style={{ height: "50vh", opacity: 0 }}
        >
          <div className="container">
            <h2>
              Seeking an offer where you have nothing to lose? Reach out to us;
              we have FREE offer plans designed just for you.
            </h2>
          </div>
        </section>

        <section
          className="contentTextSeven for_css_text fullpageScroll"
          style={{ height: "40vh", opacity: 0 }}
        >
          <h3 className="cta_btn">
            {" "}
            <button className="inside_btn get_started" onClick={handleClick}>
              Contact Us Now!
            </button>
          </h3>
        </section>
      </main>
      {/* Banner Component End Here */}
    </>
  );
};

export default Banner;
